import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./assets/css/tailwind.output.css";
import App from "./App";
import { SidebarProvider } from "./context/SidebarContext";
import ThemedSuspense from "./components/ThemedSuspense";
import { Windmill } from "@windmill/react-ui";
import * as serviceWorker from "./serviceWorker";

import { positions, Provider } from "react-alert";
import CustomAlertTemplate from "./components/Alert/CustomAlert";

const options = {
  timeout: 5000,
  position: positions.BOTTOM_CENTER,
};

const root = createRoot(document.getElementById("root"));

root.render(
  <SidebarProvider>
    <Suspense fallback={<ThemedSuspense />}>
      <Windmill usePreferences>
        <Provider template={CustomAlertTemplate} {...options}>
          <App />
        </Provider>
      </Windmill>
    </Suspense>
  </SidebarProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
